import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const Receptacle = props => (
  <SvgIcon viewBox="0 0 101 91" {...props}>
    <g id="Group_1" data-name="Group 1" transform="translate(-129 -1)">
      <g
        id="Rectangle_1"
        data-name="Rectangle 1"
        transform="translate(129 1)"
        fill="#f6f5f1"
        stroke="#195a7c"
        strokeWidth="5"
      >
        <rect width="101" height="91" rx="31" stroke="none" />
        <rect x="2.5" y="2.5" width="96" height="86" rx="28.5" fill="none" />
      </g>
      <rect
        id="Rectangle_2"
        data-name="Rectangle 2"
        width="10"
        height="27"
        transform="translate(157 23)"
        fill="#195a7c"
      />
      <rect
        id="Rectangle_3"
        data-name="Rectangle 3"
        width="10"
        height="27"
        transform="translate(192 23)"
        fill="#195a7c"
      />
      <path
        id="Rectangle_4"
        data-name="Rectangle 4"
        d="M7,0h7a6,6,0,0,1,6,6V19a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7A7,7,0,0,1,7,0Z"
        transform="translate(169 57)"
        fill="#195a7c"
      />
    </g>
  </SvgIcon>
);

export default Receptacle;
